import styled from 'styled-components';

export const StyledImagePage = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }

  .centered-translations {
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .audio-container {
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    button {
      background: white;
    }
  }
`;
